var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaveIconActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.119141,
    y: 0.976562,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3595 12.3836C14.8329 11.6503 15.6595 11.1703 16.5929 11.1703C18.0662 11.1703 19.2595 12.3636 19.2595 13.837C19.2595 14.7703 18.7795 15.597 18.0462 16.0703L14.3595 12.3836ZM21.9262 19.9503C21.9129 19.217 21.5062 18.5436 20.8529 18.2036C20.4929 18.017 20.0995 17.8436 19.6729 17.697L21.9262 19.9503ZM22.7195 22.6303L10.4662 10.377L9.51953 11.317L15.4462 17.2436C14.2395 17.397 13.1862 17.7703 12.3329 18.2103C11.6662 18.5503 11.2595 19.237 11.2595 19.9836V21.837H20.0395L21.7795 23.577L22.7195 22.6303Z",
    fill: "#FD7E14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveIconActivate);
export default __webpack_public_path__ + "static/media/leaveIconActivate.1f378ef9b1989da75adb7607153b2701.svg";
export { ForwardRef as ReactComponent };